import {
  BaseComponent,
  environment,
  FetchMenuList,
  MenuListState,
  MenuList,
  CategoryList,
  ClearOrderResponseMessage,
  LocationState,
  Location,
  FetchLocationStatus,
  DeliveryState,
  Delivery,
  WhitelabelState,
  CartState,
} from '@moduurnv2/libs-orderingapp/src/core';
import { OnInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs/internal/Observable';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

export class MenuListBaseComponent extends BaseComponent implements OnInit {
  @Select(MenuListState.getMenuList) menuList$: Observable<MenuList>;
  @Select(MenuListState.getMenuListCategories) categories$: Observable<
    CategoryList[]
  >;
  @Select(MenuListState.getMenuListCategory) category$: Observable<
    CategoryList
  >;
  @Select(LocationState.getSelectedLocation) location$: Observable<Location>;
  @Select(DeliveryState.getSelectedDelivery) delivery$: Observable<Delivery>;
  // items = this.menuList$[0].categories;
  selectedCategory: any;
  searchText: string = '';
  imgBasePath: string = environment.image_basepath;
  location: Location;
  delivery: Delivery;
  isFuture: boolean = false;
  bannerImg: string;
  constructor(public store: Store, private route: ActivatedRoute) {
    super();
    let whitelabel = this.store.selectSnapshot(WhitelabelState.getWhitelabel);
    if (whitelabel)
      this.bannerImg = environment.imagebaseurl + whitelabel.appSliderImages[0];
    this.location$.pipe(takeUntil(this.destroy$)).subscribe((location) => {
      if (location) {
        this.location = location;
      }
    });
    this.delivery$.pipe(takeUntil(this.destroy$)).subscribe((delivery) => {
      if (delivery) {
        this.delivery = delivery;
      }
    });
  }

  ngOnInit() {
    const { sectionId } = this.route.snapshot.params;
    this.store.dispatch(new FetchMenuList(sectionId));
    this.getShifts();
  }
  getItems(value) {
    // let data = this.items.filter((item) => item._id == value);
    // this.selectedCategory = data[0].items;
  }

  public getShifts() {
    const locationId = this.location?._id;
    const orderType = this.delivery?.textCode;
    const futureDate = this.store.selectSnapshot(CartState.getFutureDate);

    let currDate = new Date();
    if (futureDate) currDate = new Date(futureDate);
    let url =
      environment.mobileStoreApiUrl +
      'stores/location/' +
      locationId +
      '/shifts?type=' +
      orderType +
      '&currentTime=' +
      currDate.toISOString() +
      '&timezoneOffset=' +
      currDate.getTimezoneOffset();
    if (this.isFuture) {
      url =
        environment.mobileStoreApiUrl +
        'stores/location/' +
        locationId +
        '/shifts?type=' +
        orderType +
        '&currentTime=' +
        currDate.toISOString() +
        '&future=true&selectedTime=' +
        localStorage.getItem('pickupTime') +
        '&timezoneOffset=' +
        currDate.getTimezoneOffset();
    }
    this.store.dispatch(new FetchLocationStatus(url));
  }
}
